<template>
    <div class="scroll-box flex-center-start">
        <i class="el-icon-message-solid"></i>
            <ul>
                <li>您的提额申请已经通过初审，需要补充资料，请尽快处理1</li>
                <li>您的提额申请已经通过初审，需要补充资料，请尽快处理2</li>
                <li>您的提额申请已经通过初审，需要补充资料，请尽快处理3</li>
            </ul>
            <el-button type="" size="mini" plain>补充资料</el-button>
    </div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>
<style lang="less" scoped>
.scroll-box{
    padding: 5px 10px;
    background:#f4f9ff;
    margin: 5px 0;
    font-size: 14px;
    ul{
        margin: 0 10px;
        height: 20px;
        overflow: hidden;
        li{
            list-style: none;
            animation: side 10.5s ease-in infinite;
            animation-delay: 1s;
        }
    }
    @keyframes side {
        0%,30% {
            transform: translateY(0);
        }
        33.3%,62% {
            transform: translateY(-20px);
        }
        66.7%,100%{
           transform: translateY(-40px);
        }
    }
}
</style>
